<div id="js_list_banners">
  <banner *ngFor="let item of banner; let i = index;" [banner]="item" [keyCloseBanner]="keyCloseBanner"
    (onClose)="closeBanner($event)" (handleClick)="eventButton($event)">
    <div class="text-example">
      Lorem ipsum dolor sit amet, <span>consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut.
    </div>
  </banner>
</div>
<mat-sidenav-container [ngClass]="{'mobile': (isHandset$ | async)}" id="js_container_system">
  <mat-sidenav #drawer class="sidenav" id="sidenav" [position]="sidenavPositionControl" [class.mat-elevation-z3]="true"
    [autoFocus]="false" [fixedInViewport]="(isHandset$ | async)"
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false">

    <mat-toolbar *ngIf="(isHandset$ | async)" class="brand-container">

      <!--Control the sidenav in mobile view-->
      <app-sidenav-mobile-control class="sidenav-mobile-control" [drawer]="drawer">
      </app-sidenav-mobile-control>

    </mat-toolbar>

    <!--Scroll for menu on Sidenav Menu-->
    <div class="sidenav-menu-container" [ngClass]="{'mobile': (isHandset$ | async), 'collapsed': !myCollapse}">
      <div>
        <div class="js_heigth_menu_container">
          <app-navigation-brand-logo *ngIf="!(isHandset$ | async)" [brand]="brand" [collapse]="myCollapse">
          </app-navigation-brand-logo>
          <!--Sidenav User-->
          <!-- <app-sidenav-user [link]="user" [collapse]="myCollapse" [hasEmitterLogout]="hasEmitterLogout"
            (linkClose)="handleClose($event)" (collapsedUserPanel)="receiveCollapsedUserPanel($event)"
            (emitterLogout)="handleClickLogout()"></app-sidenav-user> -->
        </div>
        <!--Sidenav Menu-->
        <div class="js_navlist_menu_container" style="overflow-y: auto; overflow-x: hidden;">
          <mat-nav-list dense>
            <app-sidenav [menus]="menus" (linkClose)="handleClose($event)" [collapse]="myCollapse">
            </app-sidenav>
          </mat-nav-list>
        </div>
      </div>

      <!--Sidenav Bottom-- Adicionei o drawer-->
      <div class="js_heigth_menu_container">
        <app-sidenav-bottom [menuBottom]="menuBottom" [drawer]="drawer" [collapseControl]="myCollapse"
          (collapse)="receiveCollapse($event)" (collapsedUserPanel)="receiveCollapsedUserPanel($event)">
        </app-sidenav-bottom>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content (scroll)="onScrollTeste($event)" class="content content-show-right">
    <div class="main-container">
      <!--Topnavbar - Desktop -->
      <app-topnavbar *ngIf="!(isHandset$ | async) && disabledTopNav" 
        class="topnavbar-fixed"
        [breakpoint]="(isHandset$ | async)"
        [title]="(title)" [pageTitles]="pageTitles" [link]="user">
        <ng-content select="[buttons-topnavbar]"></ng-content>
      </app-topnavbar>

      <!--Topnavbar - Mobile -->
      <app-topnavbar *ngIf="(isHandset$ | async) && disabledTopNav" 
        class="topnavbar-fixed"
        [breakpoint]="(isHandset$ | async)"
        [title]="(title)" [pageTitles]="pageTitles" (collapse)="receiveCollapse($event)" 
        [drawer]="drawer" [brand]="brand" [link]="user">
        <ng-content select="[buttons-topnavbar-mobile]"></ng-content>
      </app-topnavbar>

      <div class="content-container" [ngClass]="{'mobile': (isHandset$ | async)}">
        <ng-content select="[body]"></ng-content>
      </div>

      <menu-mobile *ngIf="isHandset$ | async" [menus]="menuMobile"></menu-mobile>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>